var map = {
	"./1-1.png": "bb5b",
	"./1-2.png": "b960",
	"./1-3.png": "6366",
	"./1-4.png": "be7e",
	"./1-5.png": "8e8b",
	"./1-6.png": "8edb",
	"./1-7.png": "9520",
	"./1-8.png": "7491"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "603c";